import { useTranslation } from 'react-i18next';
import { SettingsContentWrapper } from '@legacy/components/layout/SettingsContentWrapper';
import { WidgetsList } from './components';
import { PageSettingsWrapper } from '../../components/PageSettingsWrapper';

export const FrontPageSettings = () => {
  const { t: tPageSettings } = useTranslation('pageSettings');
  return (
    <PageSettingsWrapper>
      <SettingsContentWrapper
        header={tPageSettings('FrontPageHeading')}
        description={tPageSettings('NoSettingsDescription')}
      />
      <SettingsContentWrapper
        header={tPageSettings('WidgetsHeading')}
        description={tPageSettings('WidgetsDescription')}
      >
        <WidgetsList />
      </SettingsContentWrapper>
    </PageSettingsWrapper>
  );
};
